// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--1zu6i","cardImage":"Card-module--cardImage---U59J","cardText":"Card-module--cardText--108R-","cardLinkStyle":"Card-module--cardLinkStyle--2eekG"};